import React from 'react'
import {
  apiGatewayAxiosInstance,
  apiGatewayDarwinAxiosInstance,
  customersAxiosInstance,
  darwinAxiosInstance,
  domainsAxiosInstance,
  domainsReservedAxiosInstance,
  proxiedCustomersAxiosInstance,
  proxiedDomainsAxiosInstance,
  securityAxiosInstance,
} from '@nic/nic-api'

export type DarwinConfig = {
  ENVIRONMENT: 'devel' | 'production' | 'pubtest' | 'local' | 'cypress'
  SHOW_DOCS_IN_MIDA?: boolean
  DOCS_URL?: string
  DOCS_TARGET?: '_self' | '_blank'
  MIDA_HOST: string
  DARWIN_REQUEST_DURATION: number
  DARWIN_REQUEST_DURATION_CANCELLATION: number
  DARWIN_REQUEST_DURATION_DEACTIVATION: number
  JBILLING_HOST: string
  DARWIN_SERVICE_DEFAULT_ASSIGNATION_REGISTRAR_ADMIN: string //To remove soon
  DARWIN_SERVICE_DEFAULT_ASSIGNATION_REGISTRY_ADMIN: string //To remove soon
  DARWIN_SERVICE: string
  PROXIED_DARWIN_SERVICE: string
  CUSTOMERS_SERVICE: string
  SECURITY_SERVICE: string
  DOMAINS_SERVICE: string
  PROXIED_DOMAINS_SERVICE: string
  PROXIED_CUSTOMERS_SERVICE: string
  DOMAINS_RESERVED_SERVICE: string
  PROXIED_API_SERVICE: string
}

export function getWindowRunConfig(): DarwinConfig {
  // @ts-ignore
  return { ...window['runConfig'] }
}

export function shouldShowDocsInMida(): boolean {
  return Boolean(getWindowRunConfig().SHOW_DOCS_IN_MIDA)
}

export function getDocsUrl(): string {
  return getWindowRunConfig().DOCS_URL || '/docs/'
}

export function getDocsTarget(): '_self' | '_blank' {
  return getWindowRunConfig().DOCS_TARGET || '_self'
}

let docsAvailable: boolean | null = null
let docsProbe: Promise<boolean> | null = null

export function probeDocsAvailability(): Promise<boolean> {
  if (docsAvailable !== null) return Promise.resolve(docsAvailable)
  if (docsProbe) return docsProbe
  docsProbe = fetch(getDocsUrl(), { method: 'HEAD' })
    .then((r) => (docsAvailable = r.ok))
    .catch(() => (docsAvailable = false))
  return docsProbe
}

export function useDocsAvailable(): boolean {
  const [available, setAvailable] = React.useState<boolean>(docsAvailable ?? false)
  React.useEffect(() => {
    let cancelled = false
    probeDocsAvailability().then((ok) => {
      if (!cancelled) setAvailable(ok)
    })
    return () => {
      cancelled = true
    }
  }, [])
  return available
}

/**
 * Sfruttando le istanze axios recuperate dalle api si definisce
 * per ogni servizio la baseUrl per evitare di utilizzare il ReverseProxy
 *
 * Per lo sviluppo basta riferisi al darwin-config.js presente in public,
 * negli altri casi basterà configurare per ogni ambiente (devel,prod,pubtest)
 * i vari configuration-*.js che si trovano nella cartella resources
 */
// console.log('DARWIN-CONFIG:', getWindowRunConfig())
darwinAxiosInstance.defaults.baseURL = getWindowRunConfig().DARWIN_SERVICE
apiGatewayDarwinAxiosInstance.defaults.baseURL = getWindowRunConfig().PROXIED_DARWIN_SERVICE
customersAxiosInstance.defaults.baseURL = getWindowRunConfig().CUSTOMERS_SERVICE
securityAxiosInstance.defaults.baseURL = getWindowRunConfig().SECURITY_SERVICE
domainsAxiosInstance.defaults.baseURL = getWindowRunConfig().DOMAINS_SERVICE
domainsReservedAxiosInstance.defaults.baseURL = getWindowRunConfig().DOMAINS_RESERVED_SERVICE
proxiedDomainsAxiosInstance.defaults.baseURL = getWindowRunConfig().PROXIED_DOMAINS_SERVICE
proxiedCustomersAxiosInstance.defaults.baseURL = getWindowRunConfig().PROXIED_CUSTOMERS_SERVICE
apiGatewayAxiosInstance.defaults.baseURL = getWindowRunConfig().PROXIED_API_SERVICE
